import type { OnDestroy, OnInit } from '@angular/core';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastAlertService, ToastAlertType } from '@freelancer/ui/toast-alert';
import type { Subscription } from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-invitation-redirect-alert',
  template: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InvitationRedirectAlertComponent implements OnInit, OnDestroy {
  private route = inject(ActivatedRoute);
  private toastAlertService = inject(ToastAlertService);

  private alertSubscription?: Subscription;

  ngOnInit(): void {
    this.alertSubscription = this.route.queryParamMap.subscribe(params => {
      if (params.get('report_success') === 'true') {
        this.toastAlertService.open({
          message: $localize`Report successful!`,
          timeout: 5000,
          type: ToastAlertType.SUCCESS,
        });
      }
    });
  }

  ngOnDestroy(): void {
    this.alertSubscription?.unsubscribe();
  }
}
